import {
  STORE_USER, USER_SIGNED_OUT, USER_EXPIRED, STORE_USER_ERROR, LOADING_USER,
} from '../types';

export const storeUser = user => ({
  type: STORE_USER,
  payload: user,
});

export const loadingUser = () => ({
  type: LOADING_USER,
});

export const storeUserError = () => ({
  type: STORE_USER_ERROR,
});

export const userExpired = () => ({
  type: USER_EXPIRED,
});

export const userSignedOut = () => ({
  type: USER_SIGNED_OUT,
});
